import styled from 'styled-components'

export const Tab = styled.ul.attrs({
  className: 'tab tab-block',
})``
